<template>
  <!--Banner-->
  <van-swipe :autoplay="3000" style="width: 100%;height: 150px;">
    <van-swipe-item v-for="(item, index) in data" :key="index">
      <img v-lazy="item.image" :style="{'height': '100%','width':'100%'}" @click="bannerGo(index)"/>
    </van-swipe-item>
  </van-swipe>
</template>
<script>
export default {
  name: "banner",
  props: {
    data: Array, //banner数据
  },
  data() {
    return {}
  },
  methods: {
    bannerGo(i) {
      // 淘宝ID，6
      // 京东ID，7
      // 拼多多ID，8
      let obj = this.data[i]
      console.log("obj=" + JSON.stringify(obj))
      if (obj.category === '1' && obj.url) {
        this.$router.push('/common/rule?title=资讯信息&url=' + encodeURIComponent(obj.url))
      } else if (obj.category === '2' && obj.productId) {
        this.$router.push('/whyd/ydDetail?ydId=' + obj.productId)
      } else if (obj.category === '3') {
        this.$router.push('/whyd/factory/index?factoryId=' + obj.storeId)
      } else if (obj.category === '4' && obj.thirdLink) {
        this.pushTo('/common/rule?title=&url=' + encodeURIComponent(obj.thirdLink))
      } else if(obj.category === '5' && obj.productCategoryId) {
        this.$router.push('/whyd/ydCate2List?cate2Id=' + obj.productCategoryId + '&cate2Name=' + obj
          .productCategoryName)
      }
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/banner.vue